import { useState } from "react";
import { useForm } from "react-hook-form";
import { Auth } from "aws-amplify";

import Button from "../../../common/components/controls/button/styled-button";
import { InfoText } from "../../../common/components/info_text";
import { Field } from "../../../common/components/controls/field";
import { FormStepCard } from "../../../common/components/form_steps";

import { ScreenProps } from "../dtos";
import { ForgotPassForm } from "./styled";
import { textChooser } from "../../../common/util/textChooser";

export const InitialScreen = ({ dispatchScreen }: ScreenProps) => {
  const { register, handleSubmit } = useForm();
  const [error, setError] = useState({ hasError: false });

  const handleSubmition = (data: any) => {

    Auth.forgotPassword(data.who).then(() => {

      dispatchScreen({ who: data.who, currentScreen: 2 });
      // to avoid unnecessary re-rendering
      error.hasError && setError({ hasError: false });

    }).catch(() => { setError({ hasError: true }) });
  }

  return (
    <FormStepCard title={textChooser("txt13")} showBackButton={false} >
      <ForgotPassForm onSubmit={handleSubmit(handleSubmition)}>
        <h3>{textChooser("txt39")}</h3>
        <Field
          type="email"
          hasIcon={true}
          hasError={false}
          label={textChooser("txt38")}
          placeholder={textChooser("txt4")}
          testId={"who-forgot-field"}
          maxLength={35}
          minLength={6}
          hooks={{ ...register("who", { required: true }) }}
        />

        <InfoText
          text={textChooser("txt66")}
          type={"danger"}
          hidden={!error.hasError}
        />

        <Button type="submit">{textChooser("txt6")}</Button>
      </ForgotPassForm>
    </FormStepCard>
  );
}